import React from "react";
import ReactDOM from "react-dom/client";
import "./ui/layout/scss/styles.scss";
import App from "./ui/main/App";
import "./i18n/i18n";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
